// API
export const API_SAVE_DELIVERY_AREA =
  'deliveryAreas.v3_3.API_SAVE_DELIVERY_AREA';
export const API_SAVE_DELIVERY_AREA_REQUEST =
  'deliveryAreas.v3_3.API_SAVE_DELIVERY_AREA_REQUEST';
export const API_SAVE_DELIVERY_AREA_SUCCESS =
  'deliveryAreas.v3_3.API_SAVE_DELIVERY_AREA_SUCCESS';
export const API_SAVE_DELIVERY_AREA_FAILURE =
  'deliveryAreas.v3_3.API_SAVE_DELIVERY_AREA_FAILURE';

export const API_DELETE_DELIVERY_DISTANCE =
  'deliveryAreas.v3_3.API_DELETE_DELIVERY_DISTANCE';
export const API_DELETE_DELIVERY_DISTANCE_REQUEST =
  'deliveryAreas.v3_3.API_DELETE_DELIVERY_DISTANCE_REQUEST';
export const API_DELETE_DELIVERY_DISTANCE_SUCCESS =
  'deliveryAreas.v3_3.API_DELETE_DELIVERY_DISTANCE_SUCCESS';
export const API_DELETE_DELIVERY_DISTANCE_FAILURE =
  'deliveryAreas.v3_3.API_DELETE_DELIVERY_DISTANCE_FAILURE';

export type API_SAVE_DELIVERY_AREA = typeof API_SAVE_DELIVERY_AREA;
export type API_SAVE_DELIVERY_AREA_REQUEST =
  typeof API_SAVE_DELIVERY_AREA_REQUEST;
export type API_SAVE_DELIVERY_AREA_SUCCESS =
  typeof API_SAVE_DELIVERY_AREA_SUCCESS;
export type API_SAVE_DELIVERY_AREA_FAILURE =
  typeof API_SAVE_DELIVERY_AREA_FAILURE;

export type API_DELETE_DELIVERY_DISTANCE = typeof API_DELETE_DELIVERY_DISTANCE;
export type API_DELETE_DELIVERY_DISTANCE_REQUEST =
  typeof API_DELETE_DELIVERY_DISTANCE_REQUEST;
export type API_DELETE_DELIVERY_DISTANCE_SUCCESS =
  typeof API_DELETE_DELIVERY_DISTANCE_SUCCESS;
export type API_DELETE_DELIVERY_DISTANCE_FAILURE =
  typeof API_DELETE_DELIVERY_DISTANCE_FAILURE;
